<template>
  <v-snackbar v-model="snackbar" :color="getColor" outlined centered timeout="3000">
    <v-avatar size="24" style="margin-right: 10px" :color="getColor">
      <v-icon :class="iconName" size="14" color="#fff !important" />
    </v-avatar>
    {{ snackbarMsg }}
  </v-snackbar>
</template>

<script>
export default {
  name: 'SnackBar',
  props: {
    snackbar: {
      type: Boolean,
      default: true
    },
    snackbarMsg: {
      type: String,
      default: ''
    },
    iconName: {
      type: String,
      default: ''
    },
    isSuccess: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getColor() {
      return this.isSuccess ? '#32984D' : '#F50606FF'
    }
  }
}
</script>
<style scoped></style>
